<ngx-loading-bar
  color="#A12B86"
  [includeSpinner]="false"
  [includeBar]="true"
></ngx-loading-bar>
<router-outlet></router-outlet>
